import { Component } from 'preact'

export default class NewPaybarLectureViewButton extends Component {
  constructor(props) {
    super(props)

    this.showViewButton = this.showViewButton.bind(this)
  }

  componentDidMount() {
    this.updateViewButton()
  }

  componentDidUpdate() {
    this.updateViewButton()
  }

  updateViewButton() {
    if (this.props.isSubscribed) {
      this.showViewButton()
    } else {
      this.showViewFreeButton()
    }
  }

  get lectureKey() {
    return this.props.productId.replace('lecture-', '')
  }

  get viewFreeGoal() {
    return `LECTURE-${this.lectureKey.toUpperCase()}_PROMO-TOP_TRY`
  }

  get $button() {
    return $('.js__lectureViewButton')
  }

  showViewButton() {
    return this.$button
      .addClass('is__huge is__ready')
      .attr('href', `/lectures/${this.lectureKey}/watch/`)
      .attr('goal', '')
      .text('Смотреть')
  }

  showViewFreeButton() {
    return this.$button
      .removeClass('is__huge')
      .addClass('is__ready')
      .attr('href', `/lectures/${this.lectureKey}/classroom/free/`)
      .attr('goal', this.viewFreeGoal)
      .text('Смотреть бесплатно')
  }

  render() {
    return (<div />)
  }
}
